// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"Accordian_expandIcon__6KkD2","expanded":"Accordian_expanded__C9ZHf","accordion":"Accordian_accordion__c1x4L","summary":"Accordian_summary__ujXpK"};